import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//
import { SuccessIcon } from 'components/SvgIcons';
import { setStatus } from 'store/actions/application.actions';
import { API_METHODS } from 'config/constants';
import { Loader } from 'components';

import { MODAL_TYPES } from '../constants';
import { ApproveApplicationForm } from './ApproveApplicationForm';

@connect(
  ({ roleList: { processing = {}, sponsorProfileRequests = {} } }, props) => ({
    processing: processing[`connect-${props.options.userId}`],
    sponsorProfileRequests,
  }),
  (dispatch) => ({
    setStatus: bindActionCreators(setStatus, dispatch),
  }),
)
export class ApproveApplicationModal extends React.PureComponent {
  static propTypes = {
    doAccessAction: PropTypes.func,
    options: PropTypes.shape({
      userRole: PropTypes.string,
      userId: PropTypes.string,
      listDataKey: PropTypes.string,
      actionCb: PropTypes.func,
    }),
    groups: PropTypes.array,
  };

  static defaultProps = {
    options: {},
  };

  handleSubmit = async (values) => {
    const {
      setStatus,
      showModal,
      options: { applicationId, handleResponse, actionCb } = {},
    } = this.props;

    const body = { applicationId, ...values };
    const response = await setStatus(
      API_METHODS.APPLICATION_APPROVED_DOCUMENTS_PUT,
      body,
    );

    const isSuccess = handleResponse(response);

    if (isSuccess) {
      showModal(MODAL_TYPES.INFO, {
        icon: <SuccessIcon />,
        text: 'This applications has been approved.',
        confirmBtnText: 'Close',
        additionalClassNameBtn: 'mt-10',
      });

      actionCb && actionCb();
    }
  };

  render() {
    const {
      hideModal,
      options: {
        title = 'Approve Application',
        text = 'You can attach the Letter of Authorization now to confirm your approval to work with this application.',
        confirmBtnText = 'Approve',
      },
    } = this.props;

    return (
      <Loader isShow={this.props.processing}>
        <div className="white-box p-15 text-left" style={{ maxWidth: '800px' }}>
          <div className="montserrat bold fs-16">{title}</div>
          <div className="fs-12 mt-2">{text}</div>
          <ApproveApplicationForm
            onSubmit={this.handleSubmit}
            hideModal={hideModal}
            confirmBtnText={confirmBtnText}
          />
        </div>
      </Loader>
    );
  }
}
